// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tswqjznxspxjouskowil.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRzd3Fqem54c3B4am91c2tvd2lsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUzMzkyMDUsImV4cCI6MjA1MDkxNTIwNX0.PU1fe_Gz_HOv5Em24FHayg3nICuO93kAz6b2ehD9iTc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);